import React from 'react';
import Icon from '../../../components/AppIcon';

const DentalChartCard = ({ dentalChart }) => {
  const getToothStatus = (status) => {
    if (status === 'healthy') return 'text-success';
    if (status === 'watch') return 'text-warning';
    if (status === 'treatment') return 'text-destructive';
    return 'text-foreground';
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'healthy':
        return 'CheckCircle';
      case 'watch':
        return 'AlertCircle';
      case 'treatment':
        return 'AlertTriangle';
      case 'missing':
        return 'XCircle';
      default:
        return 'Circle';
    }
  };

  return (
    <div className="bg-card rounded-xl shadow-elevation-2 border border-border p-4 md:p-6">
      <div className="flex items-center justify-between mb-4 md:mb-6">
        <h3 className="text-base md:text-lg font-semibold text-foreground">Dental Chart</h3>
        <span className="text-xs md:text-sm text-muted-foreground">{dentalChart?.lastUpdated}</span>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
        {dentalChart?.conditions?.map((condition, index) => (
          <div
            key={index}
            className="bg-muted/50 rounded-lg p-3 md:p-4 transition-smooth hover:bg-muted"
          >
            <div className="flex items-start justify-between mb-2">
              <div className="flex items-center gap-2">
                <div className="flex items-center justify-center w-8 h-8 bg-primary/10 rounded-lg">
                  <Icon name={getStatusIcon(condition?.status)} size={16} color="var(--color-primary)" />
                </div>
                <span className="text-xs md:text-sm font-medium text-muted-foreground">{condition?.area}</span>
              </div>
              {condition?.priority && (
                <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${
                  condition?.priority === 'high' ? 'bg-destructive/10 text-destructive' : 'bg-warning/10 text-warning'
                }`}>
                  {condition?.priority}
                </span>
              )}
            </div>
            
            <div className="flex items-baseline gap-2 mb-1">
              <span className={`text-sm md:text-base font-bold ${getToothStatus(condition?.status)}`}>
                {condition?.condition}
              </span>
            </div>
            
            {condition?.notes && (
              <p className="text-xs text-muted-foreground mt-1">{condition?.notes}</p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default DentalChartCard;